import { Component } from "@angular/core";
import { FirebaseAnalytics } from "@ionic-native/firebase-analytics";

@Component({
    selector: 'page-privacy-policy',
    templateUrl: 'privacy-policy.html'
})

export class PrivacyPolicyPage {

    constructor(
        public analytics: FirebaseAnalytics,
    ) {

    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('PrivacyPolicy');
    }

}



// WEBPACK FOOTER //
// ./src/pages/privacy-policy/privacy-policy.ts